package org.hs_soft.runmynesto.domain.model.home.options


enum class AllergensEnum(
    val id: String,
    val english: String,
    val german: String
) {
    Gluten(
        id = "1",
        english = "gluten",
        german = "glutenhaltiges getreide"
    ),
    Crustaceans(
        id = "2",
        english = "crustaceans",
        german = "krebstiere"
    ),
    Eggs(
        id = "3",
        english = "eggs",
        german = "eier"
    ),
    Fish(
        id = "4",
        english = "fish",
        german = "Fische"
    ),
    Peanuts(
        id = "5",
        english = "peanuts",
        german = "erdnüsse"
    ),
    Soybeans(
        id = "6",
        english = "soybeans",
        german = "soja"
    ),
    Milk(
        id = "7",
        english = "milk",
        german = "milch"
    ),
    Nuts(
        id = "8",
        english = "nuts",
        german = "hartschalenobst"
    ),
    Celery(
        id = "9",
        english = "celery",
        german = "sellerie"
    ),
    Mustard(
        id = "10",
        english = "mustard",
        german = "senf"
    ),
    SesameSeeds(
        id = "11",
        english = "sesame seeds",
        german = "sesamsamen"
    ),
    SulphurDioxide(
        id = "12",
        english = "sulphur dioxide and sulphites",
        german = "schwefeldioxid und sulfite (e220 - e228); so2"
    ),
    Lupin(
        id = "13",
        english = "lupin",
        german = "lupinen"
    ),
    Molluscs(
        id = "14",
        english = "molluscs",
        german = "weichtiere"
    )
}